export default __webpack_public_path__ + "static/media/logoColorXS.48486248.webp";